<template>
	<div :style="shu.yangshi" class="zidingyi_biaoti">
		<div class="zidingyi_biaoti_left">
			<el-image class="zidiyi_biaoti_tu" :src="shu.shu.tu" fit="cover" :style="yangshi"></el-image>
			<div class="zidingyi_biaoti_ming">{{shu.shu.ming}}</div>
		
		</div>
		<div class="zidingyi_biaoti_genduo" v-if="shu.shu.gengduo==1" >
			<span v-if="shu.gengduo==1">查看更多</span><span class="el-icon-arrow-right"></span>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'biaoti',
		props: {
			shu: {
				type: Object,
				default () {
					return {
						yangshi: {}
					}
				}
			}
		},
		data(){
			return{
				yangshi:''
			}
		},
		created() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', {
					ming: '免费专区',
					tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/eBIfBZ4RbtOvR8VR6b886z5Fvs8S5V.png',
					gengduo:1
				})
			}
			if (!this.shu.yangshi) {
				this.$set(this.shu, 'yangshi', {})
			}
		},
		watch: {
			// 分类盒子
			'shu.yangshi.width':function(){
				this.Ys();
			},
			'shu.yangshi.height':function(){
				this.Ys();
			},
			'shu.yangshi.text_align':function(){
				this.Ys();
			},
			'shu.yangshi.margin':function(){
				this.Ys();
			},
			'shu.yangshi.padding':function(){
				this.Ys();
			},
			'shu.yangshi.border_radius':function(){
				this.Ys();
			},

	},
	methods:{
		Ys(){
			this.yangshi = "";
			var px='';
			if (this.shu.yangshi.width) {
				px=(this.shu.yangshi.width>0)?(this.shu.yangshi.width+'px'):this.shu.yangshi.width;					
				this.yangshis += "width:" +px+ ";";
			}
			if (this.shu.yangshi.height) {				
				px=(this.shu.yangshi.height>0)?(this.shu.yangshi.height+'px'):this.shu.yangshi.height;		
				this.yangshi += "height:" + px+ ";";
			}
			if (this.shu.yangshi.text_align) {				
				this.yangshi += "text-align:" + this.shu.yangshi.text_align+ ";";
			}	
			if (this.shu.yangshi.margin) {
				px=(this.shu.yangshi.margin>0)?(this.shu.yangshi.margin+'px'):this.shu.yangshi.margin;		
				this.yangshi += "margin:" + px+ ";";
			}
			if (this.shu.yangshi.padding) {
				px=(this.shu.yangshi.padding>0)?(this.shu.yangshi.padding+'px'):this.shu.yangshi.padding;		
				this.yangshi += "padding:" + px+ ";";
			}
			if (this.shu.yangshi.border_radius) {
				px=(this.shu.yangshi.border_radius>0)?(this.shu.yangshi.border_radius+'px'):this.shu.yangshi.border_radius;		
				this.yangshi += "border-radius:" + px+ ";";
			}
			console.log(this.yangshi)
		},
		}
	}
</script>
<style>
	@import url("Yangshi.css");
	
</style>
